// extracted by mini-css-extract-plugin
export default {"content":"AuditingLoading_content__L70PR","loadingTitle":"AuditingLoading_loadingTitle__Y9Wwi","loader":"AuditingLoading_loader__8qZNz"};